import React from 'react';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { ScheduleSurgeryContainer } from './NoCaseScheduleSurgery.styled';
import { useHistory } from 'react-router-dom';
import { scheduleSurgeryWCMSLink } from 'src/constants/wcmsRedirectionLinks';
import { handleScheduleSurgeryClick, logErrorToConsole } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
    FIA_USER_ROLE,
    PAGE_VISIBILITY_RULE,
} from 'src/constants/appConstants';
import {
    resetBomData,
    reSetProgressBarStatus,
    resetSurgeryDetails,
    resetSurgeryDetailsReducer,
    resetShipToAddress,
    resetCreateOrUpdateSurgery,
} from 'src/pages/scheduleSurgery/redux/actions';
import { setIsMastOrder, setPediatricCheck } from 'src/common/redux/actions';
import {
    getPageVisibilityForUser,
    getUser,
} from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import { resetNotes } from 'src/common/redux/actions';

const NoCaseScheduleSurgery = (props) => {
    //redirect to schedule surgery
    const history = useHistory();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const employeeRole = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.employeeRole
    );
    const { createOrderDetails } = useSelector((state) => state.loginReducer);
    const enableOrderButtonBasedOnUser = () => {
        let showButton = false;
        const pageVisibilityRule = getPageVisibilityForUser(getUser());
        pageVisibilityRule.map((page) => {
            if (
                page &&
                page.pageRule.name === PAGE_VISIBILITY_RULE.name &&
                page.pageRule.rule === PAGE_VISIBILITY_RULE.rule
            ) {
                showButton = true;
            }
        });
        return showButton;
    };

    return (
        <ScheduleSurgeryContainer>
            <div style={{ fontSize: '14px', margin: '7px 0' }}>
                {t('calendar.orders.noScheduleLabel')}
            </div>

            {enableOrderButtonBasedOnUser() &&
                createOrderDetails.scheduleSurgery && (
                    <Button
                    
                     id={'orders-nocaseschedulesurgery-schedulesurgerylabel-button'}
                        //scheduleSurgery
                        variant={ButtonStyles?.scheduleSurgery}
                        height="3.75rem"
                        padding="10px"
                        show={props.showAddSurgeryButton}
                        borderRadius="4px"
                        fontSize="15px"
                        width="100%"
                        clicked={() => {
                            try {
                            sessionStorage.removeItem('myCaseRefID');
                            dispatch(setIsMastOrder(false));
                            dispatch(reSetProgressBarStatus());
                            dispatch(setPediatricCheck(''));
                            dispatch(resetSurgeryDetailsReducer());
                            dispatch(resetShipToAddress());
                            dispatch(resetCreateOrUpdateSurgery());
                            dispatch(resetSurgeryDetails());
                            dispatch(resetBomData());
                            dispatch(resetNotes());
                            localStorage.removeItem(
                                'alertDatesforConsignmentAdd'
                            );
                            handleScheduleSurgeryClick(
                                history,
                                scheduleSurgeryWCMSLink
                            );
                            } catch (error) {
                               logErrorToConsole(error);
                           }
                        }}
                    >
                        <span style={{ marginRight: '14px' }}>+</span>
                        {t('calendar.orders.scheduleSurgeryLabel')}
                    </Button>
                )}
        </ScheduleSurgeryContainer>
    );
};

export default NoCaseScheduleSurgery;
